var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"title":"机构信息","memo":"管理机构信息"}}),_c('a-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }